import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'
import { ResponsiveTable, TableEmptyState } from '../../../components/TableComponents'
import { StatusChip } from '../../../components/atoms'

function CriteriaHistoryDialog ({
  open,
  onClose,
  historyData,
  classes
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ style: { borderRadius: 16, backgroundColor: 'var(--color-card-bg)', color: 'var(--color-text-primary)' } }}>
      <DialogTitle style={{ borderBottom: '1px solid var(--color-border-light)' }}>
        <Typography variant="h6" style={{ fontWeight: 600, color: 'var(--color-deep-blue)' }}>
          Change History
        </Typography>
      </DialogTitle>
      <DialogContent style={{ padding: 24 }}>
        <ResponsiveTable
          columns={[
            {
              id: 'modifiedAt',
              label: 'Date',
              renderCell: (entry) => new Date(entry.modifiedAt).toLocaleString()
            },
            {
              id: 'changeType',
              label: 'Change Type',
              renderCell: (entry) => (
                <StatusChip
                  size="small"
                  label={entry.changeType}
                  color={entry.changeType === 'create' ? 'success' : entry.changeType === 'update' ? 'info' : 'error'}
                  variant="soft"
                />
              )
            },
            {
              id: 'modifiedBy',
              label: 'Modified By',
              renderCell: (entry) => entry.modifiedBy
            },
            {
              id: 'criterionName',
              label: 'Name',
              renderCell: (entry) => entry.criterionName
            },
            {
              id: 'isActive',
              label: 'Status',
              renderCell: (entry) => (
                <StatusChip
                  size="small"
                  label={entry.isActive ? 'Active' : 'Inactive'}
                  color={entry.isActive ? 'success' : 'neutral'}
                />
              )
            }
          ]}
          data={historyData}
          variant="qa"
          emptyState={
            <TableEmptyState message="No history available" />
          }
          containerProps={{ className: classes.historyTable }}
        />
      </DialogContent>
      <DialogActions style={{ padding: 16, borderTop: '1px solid var(--color-border-light)' }}>
        <Button onClick={onClose} className={classes.actionButton}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

CriteriaHistoryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  historyData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    modifiedAt: PropTypes.string,
    changeType: PropTypes.string,
    modifiedBy: PropTypes.string,
    criterionName: PropTypes.string,
    isActive: PropTypes.bool
  })).isRequired,
  classes: PropTypes.object.isRequired
}

export default CriteriaHistoryDialog
